(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chryshop-hero"] && !Shopify.designMode) return;
  try {
    
  (function(){
    'use strict';
    var section = document.getElementById('ChryShopVirtualStore-{{ section.id }}');
    if(!section) return;
    if(section.__chryInit) return;
    section.__chryInit = true;

    var neon = section.querySelector('.chry-vstore__neon-glow');
    var video = section.querySelector('.chry-vstore__bg-video');

    function ensurePlay(){
      if(!video) return;
      var p = video.play();
      if(p && p.catch){ p.catch(function(){ /* autoplay blocked */ }); }
    }

    document.addEventListener('visibilitychange', function(){
      if(document.hidden){ try{ if(video) video.pause(); }catch(e){} }
      else { ensurePlay(); }
    });

    // scheduler for slower power-drops
    function scheduleLoop(){
      var min = 15000, max = 32000;
      var delay = min + Math.floor(Math.random()*(max-min));
      setTimeout(function(){ performPowerDrop(); scheduleLoop(); }, delay);
    }

    function performPowerDrop(){
      if(!section) return;
      section.classList.add('chry-glitch');
      var pre = 400 + Math.random()*600;
      var flickerDuration = 1200 + Math.random()*1200;
      var blackoutDuration = 700 + Math.random()*900;
      var recoverDuration = 900 + Math.random()*1100;

      setTimeout(function(){
        var times = 2 + Math.floor(Math.random()*3);
        var i=0;
        var intervalMs = Math.max(180, flickerDuration/(times||3));
        var flick = setInterval(function(){
          if(!section){ clearInterval(flick); return; }
          if(i%2===0) section.classList.add('chry-blackout'); else section.classList.remove('chry-blackout');
          i++;
          if(i>=times){
            clearInterval(flick);
            section.classList.add('chry-blackout');
            setTimeout(function(){
              section.classList.remove('chry-blackout');
              setTimeout(function(){ section.classList.remove('chry-glitch'); }, recoverDuration);
            }, blackoutDuration);
          }
        }, intervalMs);
      }, pre);
    }

    function neonLoop(){
      if(!neon) return;
      var raf;
      function step(now){
        if(!section) return;
        if(section.classList.contains('chry-glitch')){
          var s = (Math.sin(now/70)*1.1) + (Math.random()*1.1-0.55);
          neon.style.transform = 'translateX(' + s + 'px) scale(' + (1 + Math.abs(s)/320) + ')';
        } else {
          neon.style.transform = 'translateX(0px) scale(1)';
        }
        raf = requestAnimationFrame(step);
      }
      raf = requestAnimationFrame(step);
    }

    var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    if(!mq.matches){
      scheduleLoop();
      neonLoop();
    } else {
      if(neon) neon.style.animation = 'none';
    }

    ensurePlay();

    section.__chryDebug = { trigger: performPowerDrop, ensurePlay: ensurePlay };

    section.addEventListener('click', function(e){
      if(!video) return;
      try{
        if(video.muted){ video.muted = false; video.play(); }
        else { video.muted = true; }
      }catch(ex){}
    });

  })();

  } catch(e) { console.error(e); }
})();
})();
